import { FieldStore, FormStore, required } from '@tom-ui/utils'
import {
  HousekeepingPlanFillDirection,
  HousekeepingPlanSequencingStrategy,
  ICreateHousekeepingPlanFormData,
} from '../models/yard-setup.model'

export class CreateHousekeepingPlanFormStore extends FormStore<ICreateHousekeepingPlanFormData> {
  name: FieldStore<string>
  blockId: FieldStore<string>
  sequencingStrategy: FieldStore<HousekeepingPlanSequencingStrategy>
  fillDirection: FieldStore<HousekeepingPlanFillDirection>
  dispatchWhatFits: FieldStore<boolean>

  constructor() {
    super()

    this.name = new FieldStore('')
    this.blockId = new FieldStore('', required())
    this.sequencingStrategy = new FieldStore(
      HousekeepingPlanSequencingStrategy.OperatorConvenience,
      required(),
    )
    this.fillDirection = new FieldStore<HousekeepingPlanFillDirection>(
      HousekeepingPlanFillDirection.BayFirst,
      required(),
    )
    this.dispatchWhatFits = new FieldStore<boolean>(false)
  }

  validate = () => {
    const isBlockIdValid = this.blockId.validate()
    const isSequencingStrategyValid = this.sequencingStrategy.validate()
    const isFillDirectionValid = this.fillDirection.validate()
    return isBlockIdValid && isSequencingStrategyValid && isFillDirectionValid
  }

  get data(): ICreateHousekeepingPlanFormData {
    return {
      ...super.data,
      name: this.name.data,
      blockId: this.blockId.data,
      sequencingStrategy: this.sequencingStrategy.data,
      fillDirection: this.fillDirection.data,
      dispatchWhatFits: this.dispatchWhatFits.data,
    }
  }
}
